// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Lookup group'"></sub-header>

  <form class="filters" name="form">
    <div class="labelled-field labelled-field--short">
      <label class="control-label" for="dlc_group_name">Group Name</label>
      <input ng-model="\$ctrl.searchParams.groupName" id="dlc_group_name" type="text" autocomplete="off">
    </div>

    <div class="labelled-field labelled-field--short">
      <label class="control-label" for="dlc_cis">Group number</label>
      <input ng-model="\$ctrl.searchParams.groupNumber" id="dlc_cis" type="text" autocomplete="off">
    </div>

    <div class="labelled-field labelled-field--short">
      <label class="control-label" for="dlc_name">Customer Name</label>
      <input ng-model="\$ctrl.searchParams.customerName" id="dlc_name" type="text" autocomplete="off">
    </div>

    <!-- Product number -->
    <div class="labelled-field labelled-field--long">
      <label class="control-label" for="dlc_product">Product number</label>
      <!-- MASKED product number -->
      <input ng-if="\$ctrl.showProductMask"
             ng-model="\$ctrl.searchParams.productNumber"
             ui-mask="{{\$ctrl.productNumberMask}}"
             ui-options="{clearOnBlur: false}"
             model-view-value="true"
             id="dlc_product"
             class="extended"
             type="text"
             autocomplete="off">
      <!-- NON-MASKED product number -->
      <input ng-if="!\$ctrl.showProductMask"
             ng-model="\$ctrl.searchParams.productNumber"
             id="dlc_product"
             class="extended"
             type="text"
             autocomplete="off">
    </div>
    <span class="mask-switch" ng-if='\$ctrl.productNumberMaskSaved'>
        <div ng-if="\$ctrl.showProductMask" id="mask-icon"><i class="icon icon-align-justify"></i></div>
        <div ng-if="!\$ctrl.showProductMask" id="normal-icon"><i class="icon icon-align-justify"></i></div>
        <input id="mask-checkbox" type="checkbox" ng-model="\$ctrl.showProductMask"
               ng-change="\$ctrl.switchProductMask()"/>
    </span>

    <button class="btn btn-primary search-button" ng-click="\$ctrl.search()" ng-disabled="!\$ctrl.validSearchRequest()">
      Search
    </button>
    <button
      ng-disabled="!\$ctrl.createCustomerEnabled"
      class="btn btn-disabled search-button"
      ng-class="{'btn-primary': \$ctrl.createCustomerEnabled}"
      ng-click="\$ctrl.createGroup()"
      command-access="CreateGroupCustomer"
    >
      New group
    </button>

  </form>

  <div class="empty-message" ng-if="!\$ctrl.searchPerformed">
    <span>Please enter search criteria to lookup customer</span>
  </div>

  <div class="empty-message" ng-if="\$ctrl.emptyResults()">
    <span ng-if="!\$ctrl.centerId">No customers matching the given criteria exist</span>
    <span ng-if="\$ctrl.centerId">Center has no customer groups yet</span>
  </div>

  <div class="alert alert--danger" ng-if="\$ctrl.searchResults.length >= \$ctrl.resultLimit">
    Too many results were returned. Only the first {{\$ctrl.resultLimit}} are shown.
    Try making the query more specific.
    <button type="button" class="close" data-dismiss="alert">&times;</button>
  </div>

  <table ng-show="\$ctrl.showResults()" class="table">
    <thead>
    <tr>
      <th>No.</th>
      <th>Group Name</th>
      <th>Group Number</th>
      <th>Branch</th>
      <th>Members with active loans</th>
      <th>Total members</th>
      <th>Center name</th>
      <th>Center reference no.</th>
      <th>Center status</th>
      <th>&nbsp;</th>
    </tr>
    </thead>

    <tbody>
    <tr ng-repeat-start="result in \$ctrl.searchResults"
        class="table__row--clickable"
        ng-click="\$ctrl.showInlinePanel(result, \$event)">
      <td>{{\$index+1}}</td>
      <td>{{result.customerGroupName}}</td>
      <td>{{result.customerGroupNumber}}</td>
      <td>{{\$ctrl.branchNames[result.customerBranchId]}}</td>
      <td>{{result.membersWithActiveLoans}} members</td>
      <td>{{\$ctrl.getMemberCount(result)}} members</td>
      <td>{{result.customerGroupCenter.name}}</td>
      <td>{{result.customerGroupCenter.id}}</td>
      <td>{{\$ctrl.getGroupCenterStatus(result.customerGroupCenter)}}</td>
      <td class="table__actions"><button type="button" ng-click="\$ctrl.openCustomer(result.customerId)" class="btn btn-primary">Open</button>
      </td>
    </tr>
    <tr ng-repeat-end class="table__row--not-hoverable">
      <td colspan="100%">
        <div class="toggleable-panel-wrapper"
             ng-class="{'toggleable-panel-wrapper--toggled': \$ctrl.selectedGroupCustomerId == result.customerId}">
          <inline-panel on-hide="\$ctrl.selectedGroupCustomerId = null">
            <div class="inline-panel__container">
              <div class="inline-panel__label">With active loans:</div>
              <div class="inline-panel__value">
                <span ng-repeat="m in \$ctrl.withActiveLoans(result.members)">{{m.effectiveName}}</span>
              </div>
              <div class="inline-panel__value" ng-if="\$ctrl.withActiveLoans(result.members).length === 0">-</div>
            </div>

            <div class="inline-panel__container">
              <div class="inline-panel__label">Without active loans:</div>
              <div class="inline-panel__value">
                <span ng-repeat="m in \$ctrl.withoutActiveLoans(result.members)">{{m.effectiveName}}</span>
              </div>
              <div class="inline-panel__value" ng-if="\$ctrl.withoutActiveLoans(result.members).length === 0">-</div>
            </div>

            <div class="inline-panel-footer">
              <button type="button" ng-click="\$ctrl.openCustomer(result.customerId)" class="btn btn-primary">Open</button>
            </div>
          </inline-panel>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/lookup-customer-group/lookup-customer-group.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;